import React from 'react';
import PropTypes from 'prop-types';
import {withStore, withScreenCheck} from '../hoc';
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import Body from '../components/Body';
import Footer from '../components/Footer';
import {Card, CardImageRow} from '../components/Cards';
import Team from '../components/CompanyTeam';

/**
 * CompanyPage
 */
class CompanyPage extends React.Component {
  static displayName = 'Entreprise';
  static propTypes = {
    stores: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };

  static defaultProps = {};

  /**
   * @override
   */
  render() {
    const links = this.props.currentPage.links();
    const team = this.props.currentPage.team();
    const certificationText = this.props.currentPage.CertificationText;
    const certificationImage = this.props.currentPage.certificationImage();

    return (
      <div className="Entreprise">
        <Navbar {...this.props} />
        <Header
          {...this.props}
          images={[
            this.props.screen === 'desktop'
              ? this.props.currentPage.heroImage()
              : this.props.currentPage.heroMobileImage(),
          ]}
        >
          {this.props.currentPage.heroCaption()}
        </Header>
        <Body {...this.props}>
          {links.map(link => (
            <Card
              card={link}
              key={link.ID}
              className="tall"
              linkType="a"
              {...this.props}
            />
          ))}
          <Card title="Team" {...this.props} className="full tall">
            <Team team={team} {...this.props} />
          </Card>
          <Card
            title="Certifications"
            image={certificationImage}
            {...this.props}
            className="full image-right"
          >
            {certificationText}
          </Card>
          <CardImageRow
            title="Affiliations"
            images={this.props.currentPage.affiliationImages()}
            {...this.props}
          />
          <CardImageRow
            title="Partenaires"
            images={this.props.currentPage.partenaireImages()}
            {...this.props}
          />
        </Body>
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(CompanyPage));



// WEBPACK FOOTER //
// ./src/pages/CompanyPage.js